import LoginIcon from '@mui/icons-material/Login';
import Logout from '@mui/icons-material/Logout';
import { Avatar, Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useUser } from '../../contexts/UserContext';
import { LoginModal } from './LoginModal';

const UserButton = () => {
  const { profile, logout } = useUser();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [loginModalOpen, setLoginModalOpen] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleClose();
  };

  const handleLoginClick = () => {
    setLoginModalOpen(true);
  };

  return (
    <div>
      {profile ? (
        <>
          <Tooltip title="User Settings">
            <IconButton onClick={handleClick}>
              <Avatar 
                src={profile.picture || undefined} 
                alt={profile.name || "User"} 
              />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            onClick={handleClose}
          >
            <MenuItem disabled>
              <Typography variant="subtitle1">{profile.name}</Typography>
            </MenuItem>
            <MenuItem disabled>
              <Typography variant="body2">{profile.email}</Typography>
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </>
      ) : (
        <>
          <Tooltip title="Login">
            <IconButton onClick={handleLoginClick}>
              <LoginIcon />
            </IconButton>
          </Tooltip>
          <LoginModal 
            open={loginModalOpen} 
            onClose={() => setLoginModalOpen(false)} 
          />
        </>
      )}
    </div>
  );
};

export default UserButton;
